module.exports = __webpack_public_path__ + "battery.jpg?a71e5f5348409072938083a4e688244c";